import React, {useEffect} from 'react';

import "./PDSADoTabOne.css";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {NextButton} from "../../../../../../common/button/next-button/NextButton";
import DatePicker from "react-datepicker";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";

export const PDSADoTabOne = ({
                                 PDSA,
                                 setPDSA,
                                 setCurrentScreen,
                                 context,
                                 navigateTo,
                                 setActiveTab,
                                 active,
                                 setSpinnerText,
                                 showToaster,
                                 toolTipsEnabled
                             }) => {

    useEffect(() => {
        setActiveTab("do");
    }, []);

    const isButtonDisabled = () => {
        const processMeasureWithoutValues = PDSA.processMeasureList.filter((processMeasure) => !processMeasure.value);
        return processMeasureWithoutValues.length !== 0;
    }

    const updateProcessMeasureDataSource = (index, value) => {
        let copyOfProcessMeasureList = JSON.parse(JSON.stringify(PDSA.processMeasureList));
        copyOfProcessMeasureList[index].dataSource = value;
        setPDSA((prevState) => ({
            ...prevState,
            processMeasureList: copyOfProcessMeasureList,
        }));
    }

    const updateProcessMeasureValue = (index, value) => {
        let copyOfProcessMeasureList = JSON.parse(JSON.stringify(PDSA.processMeasureList));
        copyOfProcessMeasureList[index].value = value;
        setPDSA((prevState) => ({
            ...prevState,
            processMeasureList: copyOfProcessMeasureList,
        }));
    }

    const listItems = PDSA.processMeasureList.map((processMeasure, index) => {
        return (
            <div key={index} className="do-tab-one-process-measure-list-item">
                <p className="do-tab-one-process-measure-list-item-title">{processMeasure.name}</p>
                <div className="do-tab-one-process-measure-list-item-input-container">
                    <p>Data Source</p>
                    <input defaultValue={processMeasure.dataSource}
                           disabled={!active || !context.editMode}
                           onChange={({target}) => {
                               updateProcessMeasureDataSource(index, target.value);
                           }}/>
                </div>
                <div className="do-tab-one-process-measure-list-item-input-container">
                    <p>Value</p>
                    <input className="do-tab-one-process-measure-list-item-value-input"
                           value={processMeasure.value}
                           disabled={!active || !context.editMode}
                           onChange={({target}) => {
                               const numberOnlyRegExp = /^[0-9]*$/;
                               if (numberOnlyRegExp.test(target.value)) {
                                   updateProcessMeasureValue(index, target.value);
                               }
                           }}/>
                </div>
            </div>
        );
    })

    return (
        <div className="do-tab-one-container">
            <div className="input-container">
                <div>
                    <label>Review Date:</label>
                    {toolTipsEnabled &&
                    <ToolTip tooltipExternalReference={"pdsaReviewDate123"}
                             context={context}
                             setSpinnerText={setSpinnerText} showToaster={showToaster}
                             fieldName={"Review Date:"}/>}
                </div>
                <DatePicker selected={PDSA.reviewDate}
                            className="text-input" dateFormat='dd/MM/yyyy'
                            disabled={!active || !context.editMode}
                            showPopperArrow={false}
                            placeholderText="Select..."
                            onChange={(selectedDate) => {
                                setPDSA((prevState) => ({
                                    ...prevState,
                                    reviewDate: selectedDate
                                }));
                            }}/>
            </div>
            <div className={"label-div-tooltip-"}>
                <label className={"label"} >Process Measures:</label>
                {toolTipsEnabled &&
                <ToolTip tooltipExternalReference={"pdsaProcessMeasures123"}
                         context={context}
                         setSpinnerText={setSpinnerText} showToaster={showToaster}
                         fieldName={"Process Measures:"}/>}
            </div>
            <div className="do-tab-one-process-measure-list-container">
                {listItems}
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview"
                                onClick={() => {
                                    navigateTo("problemTree");
                                }}/>
            </div>
            <div className="pdsa-navigation-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSAPlanTabTwo")
                }}/>
                <NextButton disabled={isButtonDisabled()}
                            onClick={() => {
                                setCurrentScreen("PDSADoTabTwo")
                            }}/>
            </div>
        </div>
    );
}
